import { API } from "@/utils/constants";

/**
 * Kısa, tahmin edilebilir public indirme URL — AWS adresi yerine panel proxy
 * Örnek: /api/ses/12345678.wav
 */
export const buildPublicRecordingUrl = (cdrId) => {
  const id = Number(cdrId);
  if (!Number.isFinite(id) || id <= 0) return "";
  const base = String(API || "/api").replace(/\/+$/, "");
  return `${base}/ses/${id}.wav`;
};

export const getShareableRecordingUrl = (record) => {
  if (!record) return "";
  const id = record.id ?? record.cdr_id;
  const hasRecording = Boolean(
    String(record.recording || record.recording_url || "").trim()
  );
  if (!hasRecording || !id) return "";
  return buildPublicRecordingUrl(id);
};

export const isPublicRecordingUrl = (url) => {
  const value = String(url || "").trim();
  if (!value) return false;
  return /\/api\/ses\/\d+\.wav(?:\?.*)?$/i.test(value) || /\/ses\/\d+\.wav(?:\?.*)?$/i.test(value);
};

/** Panel kısa URL (/api/ses/12345.wav) → CDR id */
export const parsePublicSesCdrId = (url) => {
  const value = String(url || "").trim();
  if (!value) return null;
  const match = value.match(/\/ses\/(\d+)(?:\.wav)?(?:\?.*)?$/i);
  if (!match) return null;
  const id = parseInt(match[1], 10);
  return Number.isFinite(id) && id > 0 ? id : null;
};

export const normalizePublicRecordingUrl = (url, apiBase = "/api") => {
  const raw = String(url || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  const base = String(apiBase || "/api").replace(/\/+$/, "");
  if (raw.startsWith("/")) return `${typeof window !== "undefined" ? window.location.origin : ""}${raw}`;
  return `${base}/${raw.replace(/^\/+/, "")}`;
};
